import Commander from "../Commander";
import WinLines from "../WinLines";
import * as PIXI from "pixi.js-legacy";
import {pixiClearTimeout, pixiSetTimeout} from "../../framework/src/engine/pixi/pixiTimeout";

class IdleWinAnimations {
    constructor(commander) {
        this.commander = commander;
        this.audio = this.commander.audio;

        this.layer = {
            reels: this.commander.layers.reels,
            beam: this.commander.layers.win.children[0],
            wild: this.commander.layers.win.children[1],
            anim: this.commander.layers.win.children[2],
            particles: this.commander.layers.win.children[3],
            numbers: this.commander.layers.win.children[4],
            idle: {
                numbers: this.commander.layers.idleWin.children[0],
                symbols: this.commander.layers.idleWin.children[1],
                text: this.commander.layers.idleWin.children[2],
                winLines: this.commander.layers.winLines.children[1]
            }
        };

        this.timeOuts = [];
        this.winLines = [];

        this.counter = 0;
        this.lineWins = [];
    }

    init() {
        this.number = new PIXI.BitmapText("", {
            fontName: "idle_win-export",
            fontSize: 70,
            tint: 0xFFFFFF,
            align: 'center',
            letterSpacing: 0,
            maxWidth: 1280
        });
        this.number.anchor.set(0.5,0.5);
        this.number.visible = false;
        this.number.letterSpacing = -20;
        this.layer.idle.text.addChild(this.number);

        WinLines.createLines(this.layer.idle.winLines, this.winLines);
        // this.leftCircles = WinLines.createLeftCircles(this.layer.idle.winLines);
        // this.rightCircles = WinLines.createRightCircles(this.layer.idle.winLines);
    }

    run(result) {
        this.cleanUp();
        if (result.lineWins && result.lineWins.length > 0) {
            this.lineWins = IdleWinAnimations.getLastRespinLineWins(result);
            if (this.lineWins && this.lineWins.length > 0) {
                pixiSetTimeout(.5, () => {
                    this.draw();
                    this.interval = setInterval(this.draw.bind(this), 1043);
                    this.timeout = pixiSetTimeout(60.0, this.stop.bind(this));
                });
            } else {
                this.stop();
            }
        } else {
            this.stop();
        }
    }

    draw() {
        if (!document[this.commander.hidden]) {
            let lineWin = this.lineWins[this.counter%this.lineWins.length];
            if (lineWin) {
                if (this.counter > 0) {
                    let previous = this.lineWins[(this.counter - 1) % this.lineWins.length];
                    if (previous !== undefined && !(previous.type === "respin" || previous.type === "spread")) {
                        this.hideIdleWinLine(previous.line + 1);
                    }
                }
                this.showIdleWinLine(lineWin.line + 1);
                this.showIdleNumber(lineWin);
                this.counter++;
            }
        }
    }

    stop() {
        let previous = this.lineWins[(this.counter - 1) % this.lineWins.length];
        if (previous !== undefined && !(previous.type === "respin" || previous.type === "spread")) {
            this.hideIdleWinLine(previous.line + 1);
        }
        this.commander.setState("idle");
    }

    static getLastRespinLineWins(result) {
        let lineWins = [];
        for (let i = result.lineWins.length - 1; i >= 0; i--) {
            if (result.lineWins[i].type === "respin" || result.lineWins[i].type === "spread") {
                return lineWins;
            } else {
                lineWins.push(result.lineWins[i]);
            }
        }
        return lineWins.reverse();
    }

    hideIdleWinLine(number) {
        this.winLines[number-1].visible = false;
        this.hideCircle(number-1);
    }

    showIdleWinLine(number) {
        this.winLines[number-1].visible = true;
        this.showCircle(number-1);
    }

    showIdleNumber(lineWin) {
        return new Promise(res => {
            let y = [395,190,600,600,190,395,395,600,190,395];
            this.number.text = this.commander.wallet.moneyToCredit(lineWin.win);
            this.number.visible = true;
            this.number.x = 640;
            this.number.y = y[lineWin.line];
            this.number.scale.set(0,0);

            createjs.Tween.get(this.number.scale)
                .wait(200)
                .call(() => {
                    this.timeOuts.push(pixiSetTimeout(0.175, () => {this.audio.playTrack("win_IdleWin")}));
                })
                .to({x: 1.0, y: 1.0}, 300, createjs.Ease.quartOut)
                .wait(1000)
                .call(() => {
                    Commander.removeTween(this.number.scale);
                    res();
                });
        })
    }

    showCircle(number) {
        let WinLines = this.commander.WinLines;
        let left = WinLines.leftCircles.children[number];
        let right = WinLines.rightCircles.children[number];
        if (!WinLines.mouseLock[number] && !WinLines.idleLock[number]) {
            left.children[1].alpha = left.children[3].alpha = 1;
            right.children[1].alpha = right.children[3].alpha = 1;
        }
        WinLines.idleLock[number] = true;
    }

    hideCircle(number) {
        let WinLines = this.commander.WinLines;
        let left = WinLines.leftCircles.children[number];
        let right = WinLines.rightCircles.children[number];
        WinLines.idleLock[number] = false;
        if (!WinLines.mouseLock[number] && !WinLines.idleLock[number]) {
            left.children[1].alpha = left.children[3].alpha = 0;
            right.children[1].alpha = right.children[3].alpha = 0;
        }
    }

    cleanUp() {
        this.number.visible = false;
        for (;this.timeOuts.length > 0;) {
            pixiClearTimeout(this.timeOuts.pop());
        }
        this.timeOuts = [];

        if (this.timeout)
            pixiClearTimeout(this.timeout);
        clearInterval(this.interval);
        this.interval = this.timeout  = undefined;
        this.lineWins = [];
        this.counter = 0;

        for (let winLine of this.winLines) {
            winLine.visible = false;
        }
        for (let reel of this.commander.slots.getReels()) {
            reel.data.wild = false;
        }

        this.commander.WinLines.idleLock = [false, false, false, false, false, false, false, false, false, false];
    }
}
export default IdleWinAnimations;